export default "__VITE_ASSET__D6PIicJ$__"